/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Side {
    North = 0,
    East = 1,
    South = 2,
    West = 3,
    Top = 4,
    Bottom = 5,
}
